import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoPodStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.anagraficaMittenteIsNew = true;
    $scope.anagraficaDestinatarioIsNew = true;
    $scope.anagraficaVettoreIsNew = true;

    //$scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    //$scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.mittente = {};
    $scope.destinatario = {};
    $scope.vettore = {};
    $scope.PIVAType = new RegExp('(^[0-9]{11}$)|ND');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{16}$');
    let isNomeMittenteDisabled;
    let isCognomeMittenteDisabled;
    let isRagioneSocialeMittenteDisabled;
    let isMittenteCFDisabled;
    let isMittentePIVADisabled;
    let isNomeDestinatarioDisabled;
    let isCognomeDestinatarioDisabled;
    let isRagioneSocialeDestinatarioDisabled;
    let isDestinatarioCFDisabled;
    let isDestinatarioPIVADisabled;
    let isNomeVettoreDisabled;
    let isCognomeVettoreDisabled;
    let isRagioneSocialeVettoreDisabled;
    let isVettoreCFDisabled;
    let isVettorePIVADisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    $scope.saveAnagrafica = () => {
      let anagraficaMittente = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.mittenteNome,
        cognome: $scope.settings.mittenteCognome,
        company_name: $scope.settings.mittenteRagioneSociale,
        fiscal_code: $scope.settings.mittenteCodiceFiscale,
        piva: $scope.settings.mittentePIVA,
        type: $scope.settings.mittenteRagioneSociale !== '' ? 2 : `${$scope.settings.mittenteNome} ${$scope.settings.mittenteCognome}`.trim() !== '' ? 1 : 2
      };
      let anagraficaDestinatario = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.destinatarioNome,
        cognome: $scope.settings.destinatarioCognome,
        company_name: $scope.settings.destinatarioRagioneSociale,
        fiscal_code: $scope.settings.destinatarioCodiceFiscale,
        piva: $scope.settings.destinatarioPIVA,
        type: $scope.settings.destinatarioRagioneSociale !== '' ? 2 : `${$scope.settings.destinatarioNome} ${$scope.settings.destinatarioCognome}`.trim() !== '' ? 1 : 2
      };
      let anagraficaVettore = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.vettoreNome,
        cognome: $scope.settings.vettoreCognome,
        company_name: $scope.settings.vettoreRagioneSociale,
        fiscal_code: $scope.settings.vettoreCodiceFiscale,
        piva: $scope.settings.vettorePIVA,
        type: $scope.settings.vettoreRagioneSociale !== '' ? 2 : `${$scope.settings.vettoreNome} ${$scope.settings.vettoreCognome}`.trim() !== '' ? 1 : 2
      };
      const anagrafiche = [];
      if ($scope.anagraficaMittenteIsNew) {
        anagrafiche.push(anagraficaMittente);
      }
      if ($scope.anagraficaDestinatarioIsNew) {
        anagrafiche.push(anagraficaDestinatario);
      }
      if ($scope.anagraficaVettoreIsNew) {
        anagrafiche.push(anagraficaVettore);
      }
      for (const anagrafica of anagrafiche) {
        ArchiSmallServices.insertAnagrafica(anagrafica)
          .then((response: any) => {
            // ??
          }, (error) => {
            if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
              $rootScope.alert('error', 'Anagrafica già esistente');
            }
          });
      }
    };

    $rootScope.formsubmitted = false;

    $scope.setConservazioneSettings = () => {
      $scope.settings.mittenteRagioneSociale = $scope.mittente.anagrafica;

      $scope.settings.destinatarioRagioneSociale = $scope.destinatario.anagrafica;

      $scope.settings.vettoreRagioneSociale = $scope.vettore.anagrafica;

      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            $scope.mittente.anagrafica = $scope.settings.mittenteRagioneSociale;
            isNomeMittenteDisabled = $scope.settings.mittenteNome !== '' && $scope.settings.mittenteNome !== undefined;
            isCognomeMittenteDisabled = $scope.settings.mittenteCognome !== '' && $scope.settings.mittenteCognome !== undefined;
            isRagioneSocialeMittenteDisabled = $scope.settings.mittenteRagioneSociale !== '' && $scope.settings.mittenteRagioneSociale !== undefined;
            isMittenteCFDisabled = $scope.settings.mittenteCodiceFiscale !== '' && $scope.settings.mittenteCodiceFiscale !== undefined;
            isMittentePIVADisabled = $scope.settings.mittentePIVA !== '' && $scope.settings.mittentePIVA !== undefined;

            $scope.destinatario.anagrafica = $scope.settings.destinatarioRagioneSociale;
            isNomeDestinatarioDisabled = $scope.settings.destinatarioNome !== '' && $scope.settings.destinatarioNome !== undefined;
            isCognomeDestinatarioDisabled = $scope.settings.destinatarioCognome !== '' && $scope.settings.destinatarioCognome !== undefined;
            isRagioneSocialeDestinatarioDisabled = $scope.settings.destinatarioRagioneSociale !== '' && $scope.settings.destinatarioRagioneSociale !== undefined;
            isDestinatarioCFDisabled = $scope.settings.destinatarioCodiceFiscale !== '' && $scope.settings.destinatarioCodiceFiscale !== undefined;
            isDestinatarioPIVADisabled = $scope.settings.destinatarioPIVA !== '' && $scope.settings.destinatarioPIVA !== undefined;

            $scope.vettore.anagrafica = $scope.settings.vettoreRagioneSociale;
            isNomeVettoreDisabled = $scope.settings.vettoreNome !== '' && $scope.settings.vettoreNome !== undefined;
            isCognomeVettoreDisabled = $scope.settings.vettoreCognome !== '' && $scope.settings.vettoreCognome !== undefined;
            isRagioneSocialeVettoreDisabled = $scope.settings.vettoreRagioneSociale !== '' && $scope.settings.vettoreRagioneSociale !== undefined;
            isVettoreCFDisabled = $scope.settings.vettoreCodiceFiscale !== '' && $scope.settings.vettoreCodiceFiscale !== undefined;
            isVettorePIVADisabled = $scope.settings.vettorePIVA !== '' && $scope.settings.vettorePIVA !== undefined;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;

        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item, tipo: string) => {
      if (item !== undefined && typeof item === 'object') {
        if (tipo === 'mittente') {
          if (item._id === -1) {
            $scope.settings.mittenteNome = '';
            $scope.settings.mittenteCognome = '';
            $scope.settings.mittenteRagioneSociale = '';
            $scope.settings.mittentePiva = '';
            $scope.settings.mittenteCodiceFiscale = '';
            isNomeMittenteDisabled = false;
            isCognomeMittenteDisabled = false;
            isRagioneSocialeMittenteDisabled = false;
            isMittenteCFDisabled = false;
            isMittentePIVADisabled = false;
            $scope.anagraficaMittenteIsNew = true;
          } else {
            $scope.settings.mittenteNome = item.nome;
            $scope.settings.mittenteCognome = item.cognome;
            $scope.settings.mittenteRagioneSociale = item.company_name;
            $scope.settings.mittentePiva = item.piva;
            $scope.settings.mittenteCodiceFiscale = item.fiscal_code;
            isNomeMittenteDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeMittenteDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeMittenteDisabled = item.company_name !== '' && item.company_name !== undefined;
            isMittenteCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isMittentePIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaMittenteIsNew = false;
          }
        }
        if (tipo === 'destinatario') {
          if (item._id === -1) {
            $scope.settings.destinatarioNome = '';
            $scope.settings.destinatarioCognome = '';
            $scope.settings.destinatarioRagioneSociale = '';
            $scope.settings.destinatarioPiva = '';
            $scope.settings.destinatarioCodiceFiscale = '';
            isNomeDestinatarioDisabled = false;
            isCognomeDestinatarioDisabled = false;
            isRagioneSocialeDestinatarioDisabled = false;
            isDestinatarioCFDisabled = false;
            isDestinatarioPIVADisabled = false;
            $scope.anagraficaDestinatarioIsNew = true;
          } else {
            $scope.settings.destinatarioNome = item.nome;
            $scope.settings.destinatarioCognome = item.cognome;
            $scope.settings.destinatarioRagioneSociale = item.company_name;
            $scope.settings.destinatarioPiva = item.piva;
            $scope.settings.destinatarioCodiceFiscale = item.fiscal_code;
            isNomeDestinatarioDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeDestinatarioDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeDestinatarioDisabled = item.company_name !== '' && item.company_name !== undefined;
            isDestinatarioCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isDestinatarioPIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaDestinatarioIsNew = false;
          }
        }
        if (tipo === 'vettore') {
          if (item._id === -1) {
            $scope.settings.vettoreNome = '';
            $scope.settings.vettoreCognome = '';
            $scope.settings.vettoreRagioneSociale = '';
            $scope.settings.vettorePiva = '';
            $scope.settings.vettoreCodiceFiscale = '';
            isNomeVettoreDisabled = false;
            isCognomeVettoreDisabled = false;
            isRagioneSocialeVettoreDisabled = false;
            isVettoreCFDisabled = false;
            isVettorePIVADisabled = false;
            $scope.anagraficaVettoreIsNew = true;
          } else {
            $scope.settings.vettoreNome = item.nome;
            $scope.settings.vettoreCognome = item.cognome;
            $scope.settings.vettoreRagioneSociale = item.company_name;
            $scope.settings.vettorePiva = item.piva;
            $scope.settings.vettoreCodiceFiscale = item.fiscal_code;
            isNomeVettoreDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeVettoreDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeVettoreDisabled = item.company_name !== '' && item.company_name !== undefined;
            isVettoreCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isVettorePIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaVettoreIsNew = false;
          }
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);
      if ($select.ngModel.$name === 'mittente') {
        $scope.mittente.anagrafica = '';
        $scope.settings.mittentePiva = '';
        $scope.settings.mittenteCodiceFiscale = '';
        isMittenteCFDisabled = false;
        isMittentePIVADisabled = false;
        $scope.anagraficaMittenteIsNew = false;
      }
      if ($select.ngModel.$name === 'destinatario') {
        $scope.destinatario.anagrafica = '';
        $scope.settings.destinatarioPiva = '';
        $scope.settings.destinatarioCodiceFiscale = '';
        isDestinatarioCFDisabled = false;
        isDestinatarioPIVADisabled = false;
        $scope.anagraficaDestinatarioIsNew = false;
      }
      if ($select.ngModel.$name === 'vettore') {
        $scope.vettore.anagrafica = '';
        $scope.settings.vettorePiva = '';
        $scope.settings.vettoreCodiceFiscale = '';
        isVettoreCFDisabled = false;
        isVettorePIVADisabled = false;
        $scope.anagraficaVettoreIsNew = false;
      }
    };

    $scope.isNomeMittenteDisabled = () => {
      return isNomeMittenteDisabled;
    };
    $scope.isCognomeMittenteDisabled = () => {
      return isCognomeMittenteDisabled;
    };
    $scope.isRagioneSocialeMittenteDisabled = () => {
      return isRagioneSocialeMittenteDisabled;
    };
    $scope.isMittenteCFDisabled = () => {
      return isMittenteCFDisabled;
    };
    $scope.isMittentePIVADisabled = () => {
      return isMittentePIVADisabled;
    };

    $scope.isNomeDestinatarioDisabled = () => {
      return isNomeDestinatarioDisabled;
    };
    $scope.isCognomeDestinatarioDisabled = () => {
      return isCognomeDestinatarioDisabled;
    };
    $scope.isRagioneSocialeDestinatarioDisabled = () => {
      return isRagioneSocialeDestinatarioDisabled;
    };
    $scope.isDestinatarioCFDisabled = () => {
      return isDestinatarioCFDisabled;
    };
    $scope.isDestinatarioPIVADisabled = () => {
      return isDestinatarioPIVADisabled;
    };

    $scope.isNomeVettoreDisabled = () => {
      return isNomeVettoreDisabled;
    };
    $scope.isCognomeVettoreDisabled = () => {
      return isCognomeVettoreDisabled;
    };
    $scope.isRagioneSocialeVettoreDisabled = () => {
      return isRagioneSocialeVettoreDisabled;
    };
    $scope.isVettoreCFDisabled = () => {
      return isVettoreCFDisabled;
    };
    $scope.isVettorePIVADisabled = () => {
      return isVettorePIVADisabled;
    };

    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.dpOpened = {
      dataDocumento: false,
    };

    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    // <editor-fold desc='openPODModal'>
    $scope.openPODModal = (size) => {

      $scope.saveAnagrafica();

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');
      // $scope.settings.mittenteRagioneSociale = $scope.mittente.anagrafica.company_name;
      // $scope.settings.mittenteNome = $scope.mittente.anagrafica.nome;
      // $scope.settings.mittenteCognome = $scope.mittente.anagrafica.cognome;

      // $scope.settings.destinatarioRagioneSociale = $scope.destinatario.anagrafica.company_name;
      // $scope.settings.destinatarioNome = $scope.destinatario.anagrafica.nome;
      // $scope.settings.destinatarioCognome = $scope.destinatario.anagrafica.cognome;

      // $scope.settings.vettoreRagioneSociale = $scope.vettore.anagrafica.company_name;
      // $scope.settings.vettoreNome = $scope.vettore.anagrafica.nome;
      // $scope.settings.vettoreCognome = $scope.vettore.anagrafica.cognome;

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerPodModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

  }
}

export const ConservazioneCaricaDocumentoPodStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-pod-step2.html'),
  controller: ConservazioneCaricaDocumentoPodStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-pod-step2/conservazione-carica-documento-pod-step2.ts